/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as React from 'react';

import {
  Paper,
  Popper,
  MenuList,
  MenuItem,
  Button,
  Grow,
  ClickAwayListener,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import BR from 'assets/svg/brazil.svg';
import ES from 'assets/svg/spain.svg';
import US from 'assets/svg/uStates.svg';
import CH from 'assets/svg/China.svg';
import { useEffect } from 'react';

interface IOptionsLanguageProps {
  expanded: any;
  isCurrentLanguage: (prop: string) => void;
}

export const OptionsLanguage: React.FC<IOptionsLanguageProps> = ({
  expanded,
  isCurrentLanguage,
}) => {
  const [open, setOpen] = React.useState(false);

  const isLanguage = localStorage.getItem('i18nextLng');

  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const { i18n } = useTranslation();

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  const prevOpen = React.useRef(open);

  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current!.focus();
    }

    prevOpen.current = open;
  }, [open]);

  function handleChangeLanguage(language: string) {
    i18n.changeLanguage(language);
    isCurrentLanguage(language);
    handleClose();
  }

  useEffect(() => {
    if (expanded.expanded) {
      setOpen(false);
    }
  }, [expanded]);

  return (
    <div>
      <div className="containerTitle" style={{ margin: '10px' }}>
        <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? 'composition-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          {expanded ? (
            <p className="titleMenuLanguage">
              {isLanguage === 'pt-BR' && (
                <>
                  <img src={BR} alt="" /> Português-BR
                </>
              )}
              {isLanguage === 'en-US' && (
                <>
                  <img src={US} alt="" /> Inglês-US
                </>
              )}
              {isLanguage === 'es' && (
                <>
                  <img src={ES} alt="" /> Espanhol-ES
                </>
              )}
              {isLanguage === 'zh-CN' && (
                <>
                  <img src={CH} alt="" /> 普通话-中文
                </>
              )}
            </p>
          ) : (
            <p>
              {isLanguage === 'pt-BR' && (
                <>
                  <img src={BR} alt="" />
                </>
              )}
              {isLanguage === 'en-US' && (
                <>
                  <img src={US} alt="" />
                </>
              )}
              {isLanguage === 'es' && (
                <>
                  <img src={ES} alt="" />
                </>
              )}
              {isLanguage === 'zh-CN' && (
                <>
                  <img src={CH} alt="" />
                </>
              )}
            </p>
          )}
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="bottom-start"
          transition
          disablePortal
          className="containerPopper"
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper>
                {/* @ts-ignore */}
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    <div className="TitleLanguage">
                      <MenuItem
                        onClick={() => {
                          handleChangeLanguage('pt-BR');
                        }}
                      >
                        {expanded ? (
                          <>
                            <img src={BR} alt="" /> Português-BR
                          </>
                        ) : (
                          <img src={BR} alt="" />
                        )}
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleChangeLanguage('es');
                        }}
                      >
                        {expanded ? (
                          <>
                            <img src={ES} alt="" /> Espanhol-ES
                          </>
                        ) : (
                          <img src={ES} alt="" />
                        )}
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleChangeLanguage('en-US');
                        }}
                      >
                        {expanded ? (
                          <>
                            <img src={US} alt="" /> Inglês-US
                          </>
                        ) : (
                          <img src={US} alt="" />
                        )}
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleChangeLanguage('zh-CN');
                        }}
                      >
                        {expanded ? (
                          <>
                            <img src={CH} alt="" /> 普通话-中文
                          </>
                        ) : (
                          <img src={CH} alt="" />
                        )}
                      </MenuItem>
                    </div>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
};
export default OptionsLanguage;
